<template>
  <span
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "DangerBadge",
  props: ["label"],
};
</script>
